import './fa.css';

import type React from 'react';
import type { Ref } from 'react';
import { useId } from 'react';

export interface IconDefinition {
  prefix: string;
  iconName: string;
  icon: [number, number, string[], string, string | string[]];
  fillRule?: React.SVGAttributes<SVGPathElement>['fillRule'];
  clipRule?: React.SVGAttributes<SVGPathElement>['clipRule'];
}

export type FontAwesomeIconProps = {
  'aria-label'?: string;
  className?: string;
  color?: string;
  fontSize?: string | number;
  height?: string | number;
  size?: string;
  title?: string;
  width?: string | number;
  icon: IconDefinition;
  ref?: Ref<SVGSVGElement>;
};

export const FontAwesomeIcon = ({ ref, ...props }: FontAwesomeIconProps) => {
  const id = useId();

  return (
    <svg
      ref={ref}
      aria-labelledby={props.title ? id : undefined}
      aria-hidden={props.title ? undefined : 'true'}
      aria-label={props['aria-label']}
      focusable={props.title ? undefined : 'false'}
      data-prefix={props.icon.prefix}
      data-icon={props.icon.iconName}
      className={[
        'svg-inline--fa',
        `fa-${props.icon.iconName}`,
        props.size ? `fa-${props.size}` : null,
        props.className ?? '',
      ]
        .filter(e => e != null)
        .join(' ')}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${props.icon.icon[0]} ${props.icon.icon[1]}`}
      width={props.width}
      height={props.height}
      fontSize={props.fontSize}
      color={props.color}
    >
      {props.title ? <title id={id}>{props.title}</title> : null}
      <path
        fill="currentColor"
        d={props.icon.icon[4] as string}
        fillRule={props.icon.fillRule}
        clipRule={props.icon.clipRule}
      />
    </svg>
  );
};
